const OtpBox = ({ length = 6, value, setValue }) => {
  const handleChange = (index, val) => {
    if (!/^[0-9]?$/.test(val)) return;
    const newOtp = [...value];

    newOtp[index] = val;
    setValue(newOtp);

    if (value && index < length - 1) {
      document.getElementById(`value-${index + 1}`).focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !value[index] && index > 0) {
      document.getElementById(`value-${index - 1}`).focus();
    }
  };

  return (
    <div className="flex flex-col items-center gap-4 w-full">
      <div className="flex gap-2">
        {value.map((digit, index) => (
          <input
            key={index}
            id={`value-${index}`}
            type="text"
            value={digit}
            maxLength="1"
            className="size-12 text-center text-lg border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
          />
        ))}
      </div>
    </div>
  );
};

export default OtpBox;
